// extracted by mini-css-extract-plugin
export default {"CandidatesFilterBlock":"FilterBlock_CandidatesFilterBlock__skEWd","CandidatesFilterBlockField":"FilterBlock_CandidatesFilterBlockField__kR-an"};